import { HStack, VStack } from '@ayble-health/dashboard-components';
import {
  Outlet,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom';
import { Box } from '@chakra-ui/react';
import { useDashboardPageState } from '../../hooks/useDashboardPageState';
import { Loader } from '../Loader';
import { UserDashboardSideContent } from './UserDashboardSideContent';

const { REACT_APP_HEALTHIE_URL } = process.env;

export const UserDashboardPage = () => {
  const {
    state: { loading: isFetchingDashboardData, user },
  } = useDashboardPageState();
  const { patient: patientId, phase } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const openHealthieCharting = (chartingNoteUrl?: string | null) => {
    if (!!phase) {
      navigate(`/user-details/${patientId}?${searchParams}`);
    }

    // if there's a note url, open it. Else, open charting notes
    if (chartingNoteUrl) {
      window.open(chartingNoteUrl, 'healthie');
    } else if (user?.healthie_id) {
      window.open(
        `${REACT_APP_HEALTHIE_URL}/users/${user.healthie_id}/private_notes`,
        'healthie'
      );
    }
  };

  return (
    <div
      className="dashboard-page"
      style={{
        height: '100vh',
        overflow: 'auto',
      }}
    >
      {isFetchingDashboardData && (
        <Box py={6} height={'100%'}>
          <Loader loading={isFetchingDashboardData} />
        </Box>
      )}

      {user && (
        <HStack backgroundColor={'white'} height={'100%'}>
          <VStack flex={1} minW={'300px'} overflow={'auto'} shadow={'6'}>
            <UserDashboardSideContent
              openHealthieCharting={openHealthieCharting}
            />
          </VStack>

          <VStack flex={3} overflow={'auto'}>
            <Outlet />
          </VStack>
        </HStack>
      )}
    </div>
  );
};
